export const Loading = (): JSX.Element => {
  return <div>Loading...</div>
}
